import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;
window.Echo = new Echo({
    broadcaster: 'reverb',
    key: process.env.MIX_REVERB_APP_KEY ?? process.env.VITE_REVERB_APP_KEY,
    wsHost: process.env.MIX_REVERB_HOST ?? process.env.VITE_REVERB_HOST ?? 'localhost',
    wsPort: process.env.MIX_REVERB_PORT ?? process.env.VITE_REVERB_PORT ?? 8080,
    wssPort: process.env.MIX_REVERB_PORT ?? process.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (process.env.MIX_REVERB_SCHEME ?? process.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
    authEndpoint: '/broadcasting/auth',
    auth: {
        headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
    },
});
